import { endpoints, request } from '!core/api';

export const marketStockExchangeServices = {
  exchangePriceTypes: ({ exchange }) =>
    request.get(
      endpoints.backoffice(`wsbGetExchangePriceTypes?exchange=${exchange}`),
    ),
  wsbGetInstrumentQuotes: ({ symbol, exchange, securityType }) =>
    request.get(
      endpoints.chnn(
        `wsbGetInstrumentQuotes?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
};
